import { Injectable, EventEmitter } from '@angular/core';
var left = 'left';
var right = 'right';
var BsCalendarOptionsClass = (function () {
    function BsCalendarOptionsClass() {
        this.onUpdate = new EventEmitter();
        this._offset = 1;
    }
    Object.defineProperty(BsCalendarOptionsClass.prototype, "offset", {
        get: function () {
            return this.isLeft ? 0 : this._offset;
        },
        set: function (value) {
            this._offset = value;
        },
        enumerable: true,
        configurable: true
    });
    BsCalendarOptionsClass.prototype.update = function (value) {
        Object.assign(this, value);
        this.onUpdate.emit(this);
    };
    Object.defineProperty(BsCalendarOptionsClass.prototype, "isLeft", {
        get: function () {
            return this.bsRole === left;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BsCalendarOptionsClass.prototype, "isRight", {
        get: function () {
            return this.bsRole === right;
        },
        enumerable: true,
        configurable: true
    });
    BsCalendarOptionsClass.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    BsCalendarOptionsClass.ctorParameters = function () { return []; };
    return BsCalendarOptionsClass;
}());
export { BsCalendarOptionsClass };
//# sourceMappingURL=bs-calendar-options.provider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker2/common/bs-calendar-options.provider.js
// module id = 85
// module chunks = 103